import styled from 'styled-components'

export const Content = styled.div<{ $hasFilters?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  font-family: 'Inter', sans-serif;  margin-top: 15px;`;

export const TableContainer = styled.div`
  flex: 1;
  min-height: 0;
  width: 100%;
  overflow: auto;
  padding-right: 10px;
  box-sizing: border-box;

  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #c0c0c0;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #ffffff;
    border-radius: 10px;
    border: 2px solid #c0c0c0;
  }
`;